var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const Svg24 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12.749 11.25H4.75a.75.75 0 100 1.5H19.249a.75.75 0 000-1.5h-6.5z",
  fill: "currentColor"
})));
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik0xMi43NDkgMTEuMjQ5Nkg0Ljc1QzQuMzM1NzkgMTEuMjQ5NiA0IDExLjU4NTMgNCAxMS45OTk2QzQgMTIuNDEzOCA0LjMzNTc5IDEyLjc0OTYgNC43NSAxMi43NDk2SDEyLjc0OUgxOS4yNDkxQzE5LjY2MzMgMTIuNzQ5NiAxOS45OTkxIDEyLjQxMzggMTkuOTk5MSAxMS45OTk2QzE5Ljk5OTEgMTEuNTg1MyAxOS42NjMzIDExLjI0OTYgMTkuMjQ5MSAxMS4yNDk2SDEyLjc0OVoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";
export { Svg24 as ReactComponent };